import request from "@/utils/request";
import Cookies from "js-cookie";
import ENDPOINT from "@/config/endpoint";

export async function login(data) {
  return await request({
    url: `${ENDPOINT.LANDING_PAGE_AUTH}/login`,
    method: "post",
    data,
  });
}

export function updateLoginInfo(data) {
  Cookies.set("admin_landing_page_info", JSON.stringify(data));
}

export function loginInfo() {
  try {
    return JSON.parse(Cookies.get("admin_landing_page_info"));
  } catch (_) {
    return null;
  }
}

export function logout() {
  Cookies.remove("admin_landing_page_info");
  window.location.reload();
}